//include 28
jQuery(function(){
    var sessionKey = "ppMerkliste";

    //yes, we need the session key :S
    var getSessionKey = function () {
        var merklisteSession = "merkliste=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var sessionId = null;
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(merklisteSession) == 0) {
                sessionId = c.substring(merklisteSession.length, c.length);
            }
        }
        if (sessionId == null) {
            sessionId = Math.random().toString(36).substring(7);
            document.cookie = `${merklisteSession}${sessionId};path=/`;
        }
        return sessionId;
    }
    sessionKey += getSessionKey();

    var itemTemplate = {
        group: "",
        template: "poi",
        url: "",
        data: {}
    };


    var privateFunctions = {
        get() {
            var merkliste = window.pixelpoint.sessionService.get(sessionKey);
            return merkliste;
        },
        count() {
            var merkliste = privateFunctions.get();
            if (!!merkliste)
                return Object.keys(merkliste).length;
            return 0;
        },
        set(merkliste) {
            window.pixelpoint.sessionService.set(sessionKey, merkliste);
        },
        clear() {
            window.pixelpoint.sessionService.set(sessionKey, {});
            privateFunctions.updateCount();
        },
        addOrUpdate(item, id) {
            var merkliste = privateFunctions.get();
            if (!merkliste) {
                merkliste = {};
            }
            merkliste[id] = item;
            privateFunctions.set(merkliste);
            privateFunctions.updateCount();
        },
        remove(id) {
            var merkliste = privateFunctions.get();
            if (!merkliste)
                return;
            if (!!merkliste[id])
                delete merkliste[id];
            privateFunctions.set(merkliste);
            privateFunctions.updateCount();
        },
        exists(id){
            var merkliste = privateFunctions.get();
            if (!merkliste)
                return false;
            if (!!merkliste[id])
                return true;
            return false;
        },
        updateCount() {
            var elementsCount = privateFunctions.count();
            var prepend = $(".header-wrapper .header .controls .control.icon-star-after, .header-wrapper .header .controls .control .icon-star").data("prepend") || "";
            var prependMobile = $("#offCanvas .controls .control.icon-star-after, #offCanvas .controls .control .icon-star").data("prepend") || "";
            $(".header-wrapper .header .controls .control.icon-star-after, .header-wrapper .header .controls .control .icon-star").text(prepend + elementsCount);
            var mobile = $("#offCanvas .controls .control.icon-star-after, #offCanvas .controls .control .icon-star");
            var span = mobile.find("span");
            if(span.length == 0){
                span = $('<span></span>');
                mobile.append(span);
            }
            span.text(prependMobile + elementsCount);

            //console.log(elementsCount);
        },
        createItem(data) {
            var item = $.extend(true, {}, itemTemplate);
            var itemKeys = Object.keys(item);
            for (var i in data) {
                if ($.inArray(i, itemKeys) > -1 && i != "data") {
                    item[i] = data[i];
                }
                else if (i == "data") {
                    $.extend({}, item[i], data[i]);
                }
                else {
                    item.data[i] = data[i];
                }
            }
            return item;
        }
    };

    privateFunctions.updateCount();

    window.pixelpoint.merkliste = {
        get(id){
            var merkliste = privateFunctions.get();
            if (!merkliste)
                return null;
            if (!!merkliste[id])
                return null;
            return merkliste[id];
        },
        getAll(){
            var merkliste = privateFunctions.get();
            return merkliste;
        },
        addOrUpdate(data,id){
            var item = privateFunctions.createItem(data);
            privateFunctions.addOrUpdate(item, id);
            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.checkBookmarks);
        },
        remove(id) {
            privateFunctions.remove(id);
            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.checkBookmarks);
        },
        clear() {
            privateFunctions.clear();
            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.checkBookmarks);
        },
        count() {
            return privateFunctions.count();
        },
        exists(id) {
            return privateFunctions.exists(id);
        }
    }

});